import { render, staticRenderFns } from "./white-labeling-settings.vue?vue&type=template&id=6c8607e2&"
import script from "./white-labeling-settings.ts?vue&type=script&lang=ts&"
export * from "./white-labeling-settings.ts?vue&type=script&lang=ts&"
import style0 from "./white-labeling-settings.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports